(() => {
  const targets = new Set();
  const widths = new WeakMap();
  let frame = 0;
  const fits = node => {
    const line = Number.parseFloat(getComputedStyle(node).lineHeight);
    return node.scrollWidth <= node.clientWidth + 1 && node.scrollHeight <= line * 3 + 1;
  };
  const fit = node => {
    if (!node.isConnected || node.clientWidth < 1) return;
    node.style.removeProperty('--ve-album-fit');
    const base = Number.parseFloat(getComputedStyle(node).fontSize);
    const minimum = Math.min(base, node.closest('.album-title') ? 20 : 12);
    if (fits(node)) return;
    let low = minimum;
    let high = base;
    node.style.setProperty('--ve-album-fit', low + 'px');
    if (!fits(node)) return;
    for (let step = 0; step < 9; step++) {
      const middle = (low + high) / 2;
      node.style.setProperty('--ve-album-fit', middle + 'px');
      if (fits(node)) low = middle; else high = middle;
    }
    node.style.setProperty('--ve-album-fit', Math.floor(low * 10) / 10 + 'px');
  };
  const queue = node => {
    targets.add(node);
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      for (const target of targets) fit(target);
      targets.clear();
    });
  };
  const observer = new ResizeObserver(entries => {
    for (const entry of entries) {
      if (widths.get(entry.target) === entry.contentRect.width) continue;
      widths.set(entry.target, entry.contentRect.width);
      queue(entry.target);
    }
  });
  const scan = () => document.querySelectorAll('[data-ve-album-name]').forEach(node => {
    observer.observe(node);
    queue(node);
  });
  const changes = new MutationObserver(records => {
    for (const record of records) {
      const parent = record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
      const title = parent?.closest('[data-ve-album-name]');
      if (title) queue(title);
      if (record.type === 'childList' && [...record.addedNodes].some(node => node.nodeType === Node.ELEMENT_NODE && (node.matches('[data-ve-album-name]') || node.querySelector('[data-ve-album-name]')))) scan();
    }
  });
  scan();
  changes.observe(document.body, { subtree: true, childList: true, characterData: true });
  window.addEventListener('resize', scan, { passive: true });
  document.fonts?.ready.then(scan);
  document.addEventListener('shopify:section:load', scan);
})();
